<template>
    <div class="content-electrolic-lecture margin-top-10">
        <div class="row">
            <div class="col-md-7">
                <!-- <div class="name-electronic-lecture">
                    <h4><strong>{{ dataElectronicLecture.name }}</strong></h4>
                </div> -->
                <vueCustomScrollbar class="wrap-list-chapter indented">
                    <div class="chapter-item" v-for="(item, index) of listChapterClassSchool" :key="index">
                        <div @click="handleToggerCollapse(item)"
                            class="title-chapter border-bottom-chapter display-flex justify-content-space-between">
                            <h5>
                                {{ item.name }}
                            </h5>
                            <img v-if="item.listPostClassSchool.length > 0" class="icon-down-arrow"
                                src="@/assets/img/down-arrow.png" />
                        </div>
                        <b-collapse id="collapse_filter" class="mt-2" :visible="item.isCollapse">
                            <div class="list-interactive-lectures indented">
                                <div class="interactive-lectures-item"
                                    v-for="(post, indexPost) of item.listPostClassSchool" :key="indexPost">
                                    <div class="title-interactive-lectures display-flex justify-content-space-between">
                                        <h5>
                                            {{ post.name }}
                                        </h5>
                                        <!-- <img class="icon-down-arrow" src="@/assets/img/down-arrow.png" /> -->
                                    </div>
                                    <div class="list-document indented"
                                        v-for="(document, indexDocument) of post.listDocumentClassSchool"
                                        :key="indexDocument">
                                        <div class="wrap-document" @click="handleViewDocument(document)">
                                            <h6>
                                                <strong>{{ document.name }}</strong>
                                            </h6>
                                            <div>
                                                ({{ nameTypeDocument(document) }})
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </b-collapse>
                    </div>
                </vueCustomScrollbar>
                <div class="row pagination container m-0">
                </div>
            </div>
            <div class="col-md-5">
                <CommentContentElectronicLectureDelivered />
            </div>
        </div>
        <!-- <b-pagination pills v-model="paramQueryData.pageIndex" :total-rows="totalRecords"
            :per-page="paramQueryData.pageSize" first-number
                last-number></b-pagination> -->
        <ModalViewDocument :item="itemSelected" v-if="isOpenModalViewDocument" @closeModal="closeModalViewDocument" />
    </div>
</template>
<script>
import { TYPE_H5P, TYPE_DOCUMENT, TYPE_TEST, FILE_YOUTUBE, FILE_CANVA, FILE_LINK } from './../../../constants/constants_enum'

import CommentContentElectronicLectureDelivered from './CommentContentElectronicLectureDelivered'
import { getDetail } from './../../../_api/LessonClassSchoolServices'
import { listChapterClassSchool } from './../../../_api/chapterClassSchoolServices'
import vueCustomScrollbar from "vue-custom-scrollbar";
import ModalViewDocument from './../../../_components/ModalViewDocument.vue'
export default {
    // props:{
    //     dataElectronicLecture:{
    //         Object
    //     }
    // },
    components: {
        CommentContentElectronicLectureDelivered,
        vueCustomScrollbar,
        ModalViewDocument
    },
    data() {
        return {
            FILE_LINK,
            paramQueryData: {
                lessonClassSchoolId: 0,
                keyword: '',
                pageIndex: 1,
                pageSize: 5000000,
            },
            listTypeDocument: [
                { value: TYPE_H5P, text: 'Bài giảng tương tác H5P' },
                { value: TYPE_DOCUMENT, text: 'Dạng tài liệu' },
                { value: TYPE_TEST, text: 'Dạng kiểm tra' },
                { value: FILE_YOUTUBE, text: 'Dạng youtube' },
                { value: FILE_CANVA, text: 'Dạng canva' },
                { value: FILE_LINK, text: 'Dạng nhúng' },
            ],
            listChapterClassSchool: [],
            totalRecords: 0,
            lessonClassSchoolId: 0,
            dataElectronicLecture: {
                id: 0,
                name: '',
                bookTypeId: '',
                classId: '',
                subjectId: '',
                numberLesson: '',
                description: '',
                isPublic: false,
                type: 2
            },
            isOpenModalViewDocument: false,
            itemSelected: null
        }
    },

    mounted() {
        this.lessonClassSchoolId = this.$route.query.id
        this.paramQueryData.lessonClassSchoolId = this.$route.query.id
        //this.getListChapterClassSchool()
        this.getDetailLessonClassSchool()
        this.getListChapterClassSchool()
    },
    methods: {
        closeModalViewDocument() {
            this.isOpenModalViewDocument = false
        },
        handleViewDocument(document) {
            this.itemSelected = document
            if (document.typeDocument == FILE_LINK) {
                window.open(document.path, '_blank');
            }
            else {
                this.isOpenModalViewDocument = true
            }

        },
        handleToggerCollapse(item) {
            item.isCollapse = !item.isCollapse
        },
        nameTypeDocument(document) {
            for (let i = 0; i < this.listTypeDocument.length; i++) {
                const type = this.listTypeDocument[i];
                if (document.typeDocument == type.value) {
                    return type.text
                }
            }
            return ''
        },
        getDetailLessonClassSchool() {
            let self = this
            getDetail(this.lessonClassSchoolId).then(res => {
                if (res && res.data && !res.errors) {
                    self.dataElectronicLecture = {
                        id: res.data.id,
                        name: res.data.name,
                        bookTypeId: res.data.bookTypeId,
                        classId: res.data.classId,
                        subjectId: res.data.subjectId,
                        numberLesson: res.data.numberLesson,
                        description: res.data.description,
                        isPublic: res.data.isPublic,
                        type: res.data.type,
                    }
                }
            })
        },
        getListChapterClassSchool() {
            let self = this
            listChapterClassSchool(this.paramQueryData).then(res => {
                if (res && res.data && !res.errors) {
                    self.listChapterClassSchool = res.data.list
                    self.totalRecords = res.data.paging.totalRecords
                }
            })
        }
    }

}
</script>
<style lang="scss" scoped>
.wrap-document {
    cursor: pointer;
}

.margin-top-10 {
    margin-top: 10px;
}

.content-electrolic-lecture {
    .title-chapter {
        cursor: pointer;
        padding: 5px;
    }

    .document-item {
        color: #8599a8;
    }

}

.indented {
    margin-left: 20px;
    max-height: 60vh;
    overflow-y: auto;
    /* Đặt giá trị thụt cách tùy ý */
}

.justify-content-space-between {
    justify-content: space-between;
}

.border-bottom-chapter {
    border-bottom: 1px solid #eaedf0;
}

.border-top-chapter {
    border-top: 1px solid #eaedf0;
}

.icon-down-arrow {
    width: 20px;
    height: 20px;
}
</style>